import React, { useEffect, useState } from "react";
import { useGetDetailErrorTransactionApi } from "../../hooks/record-transaction/useGetDetailErrorTransactionApi";
import { formatMonthDate } from "../../helper";
import { useRevenueOverall } from "../../store";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";
import { Pagination } from "@nextui-org/react";
import { FooterFilterMobile } from "../../components";
import { IoMdArrowRoundBack } from "react-icons/io";

const DetailErrorPage = () => {
  const [page, setPage] = useState<number>(1);
  const [infoDetailErrorEachStore, setInfoDetailErrorEachStore] =
    useState<any>();
  const { storeCode } = useRevenueOverall();

  const navigate = useNavigate();

  const { totalDetailError } = useGetDetailErrorTransactionApi({ page });

  useEffect(() => {
    if (totalDetailError) {
      setInfoDetailErrorEachStore(totalDetailError?.data);
    }
  }, [totalDetailError]);
  return (
    <>
      <div className="h-full flex flex-col xl:gap-4 gap-2 max-md:p-[8px]">
        <div className="flex flex-col gap-2">
          <div
            onClick={() => {
              navigate(`/statistical-manage`);
            }}
            className="flex items-center gap-1 cursor-pointer"
          >
            <IoMdArrowRoundBack className="2xl:text-3xl xl:text-2xl text-xl text-gray-500" />
            {/* <span className="font-bold text-gray-700 hover:underline cursor-pointer lg:text-sm text-xs">
              Trở lại
            </span> */}
            <span className="uppercase font-bold xl:text-2xl lg:text-xl text-base text-gray-500">
              {storeCode}
            </span>
          </div>
        </div>
        <div className="flex justify-center h-[80%] items-center">
          <table className="w-full h-full b border-collapse flex flex-col">
            <div className="w-full flex items-center justify-between">
              <th className="flex justify-center items-center text-gray-600 text-center text-sm uppercase w-[10%] xl:p-[12px] lg:p-[8px] p-[6px] max-lg:text-sm max-sm:text-xs">
                STT
              </th>
              <th className="flex justify-center items-center text-gray-600 text-center text-sm uppercase w-[15%] xl:p-[12px] lg:p-[8px] p-[6px] max-lg:text-sm max-sm:text-xs">
                Store
              </th>
              <th className="flex justify-center items-center text-gray-600 text-center text-sm uppercase w-[30%] xl:p-[12px] lg:p-[8px] p-[6px] max-lg:text-sm max-sm:text-xs">
                Evident
              </th>
              <th className="flex justify-center items-center text-gray-600 text-center text-sm uppercase w-[10%] xl:p-[12px] lg:p-[8px] p-[6px] max-lg:text-sm max-sm:text-xs">
                Machine
              </th>
              <th className="flex max-sm:hidden justify-center items-center text-gray-600 text-center text-sm uppercase w-[20%] xl:p-[12px] lg:p-[8px] p-[6px] max-lg:text-sm max-sm:text-xs">
                User
              </th>
              <th className="flex justify-center items-center text-gray-600 text-center text-sm uppercase w-[15%] xl:p-[12px] lg:p-[8px] p-[6px] max-lg:text-sm max-sm:text-xs">
                Date
              </th>
              {/* <th className="flex justify-center items-center text-gray-600 text-center text-sm uppercase lg:w-[10%] w-[10%] xl:p-[12px] lg:p-[8px] p-[6px] max-lg:text-sm max-sm:text-xs"></th> */}
            </div>

            <div className="w-full bg-white h-[100%] overflow-hidden xl:p-[12px] lg:p-[8px] p-[6px] overflow-y-auto custom-scrollbar">
              {infoDetailErrorEachStore &&
                infoDetailErrorEachStore?.map((item: any, index: number) => (
                  <tr
                    key={index}
                    className=" flex items-center justify-between lg:h-fit 2xl:pb-4 xl:pb-3 lg:pb-2 pb-1 border-b-[1px] my-2 border-gray-100 xl:pt-4 lg:pt-3 pt-2 hover:bg-gray-100 w-full"
                  >
                    <td className="flex justify-center items-center w-[10%] text-center text-sm max-lg:text-sm max-sm:text-xs">
                      {index + 1}
                    </td>
                    <td className="flex justify-center items-center w-[15%] text-center text-sm max-lg:text-sm max-sm:text-xs">
                      {item.storeCode}
                    </td>
                    <td className="flex font-semibold text-green-500 justify-center items-center w-[30%] text-center text-sm max-lg:text-sm max-sm:text-xs">
                      <img
                        src={item?.imgEvident}
                        className="2xl:w-28 lg:w-24 max-md:w-20 max-sm:w-16"
                      ></img>
                    </td>
                    <td className="flex justify-center items-center w-[10%] text-center text-sm max-lg:text-sm max-sm:text-xs">
                      {item.machineCode}
                    </td>
                    <td className="flex max-sm:hidden font-bold justify-center items-center w-[20%] text-center text-sm max-lg:text-sm max-sm:text-xs">
                      {item.email}
                    </td>
                    <td className="flex justify-center items-center xl:ml-4 w-[15%] text-center text-sm max-lg:text-sm max-sm:text-xs">
                      {item?.createDate && formatMonthDate(item.createDate)}
                    </td>
                  </tr>
                ))}
            </div>
          </table>
        </div>
        <div className="w-full flex justify-end items-center">
          <Pagination initialPage={page} total={10} onChange={setPage} />
        </div>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </>
  );
};

export default DetailErrorPage;
